const en = {
    // Existing keys
    hotkey: 'Hotkeys',
    hotkey_tips1: 'space+drag\n'+
        'alt+scroll\n'+
        '\\\n'+
        'shift+drag\n'+
        '[ ]\n'+
        'p\n'+
        'alt+click\n'+
        'delete\n'+
        '{{modifier}} + z\n'+
        '{{modifier}} + y\n'+
        '\n'+
        'b\n'+
        'n\n'+
        'm\n'+
        ',\n'+
        '\n'+
        '{{modifier}} + s\n'+
        '{{modifier}} + o\n'+
        'esc\n'+
        '?\n'+
        '',
    hotkey_tips2: 'pan\n'+
        'zoom\n'+
        'toggle grid\n'+
        'draw line\n'+
        'adjust brush size\n'+
        'square/circle brush\n'+
        'color pick\n'+
        'delete selection\n'+
        'undo\n'+
        'redo\n'+
        '\n'+
        'terrain tool \n'+
        'path tool\n'+
        'building tool\n'+
        'amenities tool\n'+
        '\n'+
        'save\n'+
        'open map file\n'+
        'main menu\n'+
        'hotkeys\n'+
        '',
    mainmenu: 'Main Menu',
    save_image: 'Save as Image',
    load_map: 'Load Map',
    new_map: 'New Map',
    clear_warn: 'Clear your map? You will lose all unsaved changes.',
    tracing_overlay: 'Tracing Overlay',
    import_tracing_overlay: 'Import Image for Tracing Overlay',
    import_tracing_overlay_instructions: '1. Upload a photo/screenshot of your map\n\n2. Mark the four corners of the grid',
    import_tracing_overlay_auto_corners: 'Screenshot detected, auto-positioning corners...',
    twitter: 'Twitter',

    // Entry point
    create_new_map: 'Create New Map',
    generate_from_screenshot: 'Generate from Screenshot',
    tile_editor: 'Tile Editor',
    draw_manually: 'Draw Manually',

    // Screenshot flow
    screenshot_title: 'Generate from Screenshot',
    screenshot_description: 'Upload a screenshot of your island map to automatically generate your island. ',
    screenshot_upload: 'Upload Screenshot',
    screenshot_not_detected: 'Failed to process image. Please upload a screenshot of the map.',
    screenshot_tips_title: 'Screenshot Tips',
    screenshot_tips_transfer_heading: 'Transferring from your Switch:',
    screenshot_tips_capture: 'Press the Capture button (square button on the left Joy-Con) to save a screenshot',
    screenshot_tips_transfer: 'To transfer: go to Album \u2192 Send to Smartphone, or copy to PC via USB or microSD card',
    screenshot_tips_actual: 'Use the actual in-game screenshot \u2014 a photo of the screen will not work',
    screenshot_tips_good_heading: 'Taking a good screenshot:',
    screenshot_tips_nookphone: 'Open your NookPhone map screen before capturing',
    screenshot_tips_stand: 'Stand somewhere like the beach so your player pin doesn\'t block map details',
    screenshot_tips_icons: 'Avoid selecting icons on the map \u2014 the generator struggles with orange highlighted icons',
    screenshot_tips_overlay: 'After generating, use the overlay tool to compare and clean up any errors',
    screenshot_flavor_0: 'Scanning island...',
    screenshot_flavor_1: 'Detecting boundaries...',
    screenshot_flavor_2: 'Analyzing terrain...',
    screenshot_flavor_3: 'Matching edge tiles...',
    screenshot_flavor_4: 'Identifying structures...',
    screenshot_flavor_5: 'Digging terrain...',
    screenshot_flavor_6: 'Rerouting rivers...',
    screenshot_flavor_7: 'Setting up amenities...',
    screenshot_flavor_8: 'Building island...',
    screenshot_flavor_9: 'Planting trees...',

    // Save tutorial
    save_tutorial_title: 'Notes on saving',
    save_tutorial_description: 'The saved image is special \u2014 your map data is encoded into the pixels.',
    save_tutorial_warning: 'Map data will be lost if you edit or compress the image!',
    save_tutorial_ok: 'Got it',

    // Upgrade flow
    cancel: 'Cancel',
    upgrade_to_v2: 'Upgrade to V2',
    upgrade_description: 'This will upgrade your map to the new format. The new format locks the beaches and edges of your island so you don\'t have to worry about drawing over it.',
    upgrade_warning: 'Save your map before converting — conversion might not produce perfect results.',
    upgrade_success: 'Conversion successful!',
    upgrade_failed: 'Conversion failed. Please try again.',
    upgrade_convert: 'Convert',
    upgrade_flavor_0: 'Analyzing edge tiles...',
    upgrade_flavor_1: 'Scanning the coastline...',
    upgrade_flavor_2: 'Looking for the airport...',
    upgrade_flavor_3: 'Searching for the dock...',
    upgrade_flavor_4: 'Mapping the peninsula...',
    upgrade_flavor_5: 'Finding the secret beach...',
    upgrade_flavor_6: 'Checking the rocks...',
    upgrade_flavor_7: 'Matching terrain patterns...',
    upgrade_flavor_8: 'Almost there...',
    upgrade_flavor_9: 'Finalizing conversion...',

    // V2 wizard steps
    wizard_river_direction: 'Select Island River Direction',
    wizard_skip: 'Skip',
    wizard_choose_terrain: 'Choose Island Terrain',
    wizard_choose_terrain_description: 'Flatten the island or choose one of the starter island layouts.',
    wizard_peninsula_side: 'Select Peninsula Side',
    wizard_dock_side: 'Dock Side?',
    wizard_choose_river_mouth: 'Choose River Mouth Shape',
    wizard_choose_peninsula_shape: 'Choose Peninsula Shape',
    wizard_choose_dock_shape: 'Choose Dock Beach Shape',
    wizard_choose_secret_beach: 'Choose Secret Beach Shape',
    wizard_choose_rock_shape: 'Choose Rock Shape',
    wizard_choose_shape: 'Choose Shape',

    // Position selectors
    wizard_select_airport: 'Select Airport Position',
    wizard_select_peninsula: 'Select Peninsula Position',
    wizard_select_secret_beach: 'Select Secret Beach Position',
    wizard_select_left_rock: 'Where is the Largest Rock on the Left Side?',
    wizard_select_right_rock: 'Where is the Largest Rock on the Right Side?',

    // Option selector
    option_swipe_confirm: 'Swipe to preview, tap to confirm',
    option_scroll_confirm: 'Scroll to preview, click to confirm',

    // Position selector prompts
    new_badge: 'NEW',
    beta_badge: 'BETA',
    click_again_confirm: 'Click again to confirm',
    tap_again_confirm: 'Tap again to confirm',
    click_location: 'Click a location',
    tap_location: 'Tap a location',
    skip_confirm: 'Skip the rest of the flow?',

    // Legacy flow
    wizard_choose_template: 'Choose a Drawing Template!',
    wizard_manual_description: 'Manual Drawing lets you redraw the entire island, but not everything will work in game.',
    wizard_choose_island: 'Choose your Island!',
    wizard_choose_island_hint: 'You probably won\'t find an exact match, but pick one that roughly resembles your island.',

    // Settings
    settings: 'Settings',
    settings_language: 'Language',
    settings_language_restart: 'Please reload the page for the language change to take effect.',
    translation_disclaimer: 'Translations may have mistakes, I used a translation tool.',
};

export default en;
